import { NgModule } from '@angular/core';
import { Facebook } from '@ionic-native/facebook/ngx';
import { Keychain } from '@ionic-native/keychain/ngx';
import { SignInWithApple } from '@ionic-native/sign-in-with-apple/ngx';

@NgModule({
  providers: [Keychain, SignInWithApple, Facebook],
})
export class AuthModule {}
